export default {
    documentTitle: 'Global Opportunity Platform',

    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',

    loading: 'Loading',
    ok: 'OK',
    save: 'Save',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    delete: 'Delete',
    remove: 'Remove',
    update: 'Update',
    cancel: 'Cancel',
    done: 'Done',
    continue: 'Continue',
    select: 'Select',
    accept: 'Accept',

    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    enter: 'Enter',

    success: 'Success',
    error: 'Error',

    no: 'No',
    yes: 'Yes',

    description: 'Description',
    default: 'Default',

    // Is used by the YearMonthPicker-component and should be an array
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],

    dialogs: {
        helperTexts: {
            checkHasPendingAction: 'Checking your pending verification',
            verifySchoolConnection: 'Verify your school connection to access these resources',
            logInToAccessMoreFeatures:
                'Connecting Business and Tech Students<br>with Employers Globally',
        },
    },
    minutesShort: 'min',

    poweredBy: 'Powered By',
    noResourcesFound: 'No resources found',
    unknown: 'Unknown',
    present: 'Present',

    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
};
